<template>
    <div>
        <UserCategoriesList/>
    </div>
</template>
<script>
    import UserCategoriesList from '../../components/users/UserCategoriesList';

    export default {
        name: 'company-categories',
        components: {UserCategoriesList},
    }
</script>